import { Http, PageQuery } from '@mygpt/app/http';

export interface EmbeddingsVectorsParams extends PageQuery {
  aiId: string;
}

/**
 * 获取机器人数据列表
 * @param params
 * @returns
 */
export const embeddingsVectors = (params: EmbeddingsVectorsParams) => {
  const { aiId, page, size } = params;
  const { get } = Http.use();
  return get(`/embeddings/vectors/${aiId}?page=${page}&size=${size}`);
};

export interface EmbedGetChunkParams {
  aiId: string;
  url: string;
  fileId: string;
}

/**
 * 获取机器人数据Chunk
 * @param params
 * @returns
 */
export const embedGetChunk = (params: EmbedGetChunkParams) => {
  const { aiId, url, fileId } = params;
  const { get } = Http.use();
  return get(`/debug/chunks`, { params: { bot_id: aiId, url, file_id: fileId } });
};
